export default __webpack_public_path__ + "0226bc2c29cb29be9acb7846e5d1b2b2.svg";